import { MdRestaurantMenu } from "react-icons/md";

import CateringToolbar from "../components/CateringToolbar/CateringToolbar";
import CateringStats from "../components/CateringStats/CateringStats";
import CateringGrid from "../components/CateringGrid/CateringGrid";

import CateringDetailsModal from "../components/CateringDetailsModal/CateringDetailsModal";
import AddEditPackageModal from "../components/AddEditPackageModal/AddEditPackageModal";

import DeleteModal from "../components/Shared/DeleteModal/DeleteModal";
import EmptyState from "../components/Shared/EmptyState/EmptyState";
import LoadingSpinner from "../components/Shared/LoadingSpinner/LoadingSpinner";

import useCatering from "../hooks/useCatering";
import useCateringForm from "../hooks/useCateringForm";

import "../styles/CateringManagementPage.css";

function CateringManagementPage() {

  const catering = useCatering();

  const cateringForm = useCateringForm(
    catering.selectedPackage,
    catering.fetchPackages
  );

  if (catering.loading) {
    return (
      <LoadingSpinner
        text="Loading Catering Packages..."
      />
    );
  }

  return (
    <div className="catering-management-page">

      <CateringToolbar
        search={catering.search}
        onSearch={catering.setSearch}
        category={catering.category}
        onCategoryChange={catering.setCategory}
        onAdd={catering.openAddModal}
      />

      <CateringStats
        packages={catering.packages}
      />

      {catering.filteredPackages.length === 0 ? (

        <EmptyState
          icon={<MdRestaurantMenu />}
          title="No Catering Packages"
          description="Start by adding your first catering package."
          buttonText="Add Package"
          onButtonClick={catering.openAddModal}
        />

      ) : (

        <CateringGrid
          packages={catering.filteredPackages}
          onView={catering.openDetails}
          onEdit={catering.openEditModal}
          onDelete={catering.openDeleteModal}
        />

      )}

      <CateringDetailsModal
        isOpen={catering.showDetails}
        packageData={catering.selectedPackage}
        onClose={catering.closeDetails}
      />

      <AddEditPackageModal
        isOpen={catering.showForm}
        onClose={catering.closeForm}
        formData={cateringForm.formData}
        updateField={cateringForm.updateField}
        submitForm={cateringForm.submitForm}
        loading={cateringForm.loading}
        editingPackage={catering.selectedPackage}
      />

      <DeleteModal
        isOpen={catering.showDelete}
        title="Delete Catering Package"
        message={`Are you sure you want to delete "${catering.selectedPackage?.packageName}"?`}
        loading={catering.deleteLoading}
        onCancel={catering.closeDelete}
        onConfirm={catering.deletePackage}
      />

    </div>
  );
}

export default CateringManagementPage;